module.exports = __webpack_public_path__ + "img/XAI8.59542e02.jpg";